import { Box, Form, Heading, LabeledControl, Paragraph } from '@zillow/constellation-10';

import { styled } from '@/styled-system/jsx';

// Design Specs: https://www.figma.com/file/2UlxeTUdKRMOHjl0h3rOg1/Starter-File-Multi-Step-Forms-AKA-Wizards?node-id=119%3A24517

export const WizardForm = styled(Form, {
  base: {
    flexGrow: 2,
  },
});

export const WizardHeading = styled(Heading, {
  base: {
    display: 'block',
    marginBottom: '400',
  },
});

export const WizardBody = styled(Paragraph, {
  base: {
    display: 'block',
    marginBottom: '600',
  },
});

export const WizardFormSectionContainer = styled(Box, {
  base: {
    marginBottom: '800',
    width: { base: '100%', xxl: '656px' },

    '&:last-child': {
      marginBottom: '600',
    },
  },
});

export const WizardFlexContainer = styled(Box, {
  base: {
    display: 'flex',
    flexDirection: { base: 'column', xxl: 'row' },
    justifyContent: 'space-between',
  },
});

export const WizardLabeledControl = styled(LabeledControl, {
  base: {
    minWidth: '50%',
  },
});

// Hacky fix for the tip card on wizard pages being aligned slightly left of the ones on other form pages.
export const WizardTipCardLeftSpacing = styled(Box, {
  base: {
    marginLeft: { xxl: '19.5px' },
  },
});
